import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import truncate from 'lodash/truncate';
import { useFloating, useInteractions, useHover, useFocus, offset, shift } from '@floating-ui/react';
import dates from '@/common/utils/date';
import styles from './styles.module.scss';

var QuestionMarkIcon = function QuestionMarkIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 2.5C4.73858 2.5 2.5 4.73858 2.5 7.5C2.5 10.2614 4.73858 12.5 7.5 12.5C10.2614 12.5 12.5 10.2614 12.5 7.5C12.5 4.73858 10.2614 2.5 7.5 2.5ZM1.25 7.5C1.25 4.04822 4.04822 1.25 7.5 1.25C10.9518 1.25 13.75 4.04822 13.75 7.5C13.75 10.9518 10.9518 13.75 7.5 13.75C4.04822 13.75 1.25 10.9518 1.25 7.5Z",
      fill: "#A0A0A0"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.95828 5.93795C6.78544 6.23674 6.40311 6.33884 6.10433 6.166C5.80554 5.99316 5.70344 5.61083 5.87628 5.31205C6.19953 4.75324 6.80525 4.375 7.50005 4.375C8.53558 4.375 9.37505 5.21447 9.37505 6.25C9.37504 6.93608 8.95419 7.49624 8.43755 7.8125C8.02256 8.06654 8.2813 8.75 7.49841 8.75C7.15323 8.75 6.87341 8.47018 6.87341 8.125C6.87341 8.10306 6.87454 8.08138 6.87675 8.06002C6.89408 7.72948 7.04147 7.46053 7.20195 7.26496C7.37143 7.05842 7.59426 6.88982 7.76465 6.78853C8.71259 6.225 7.55641 5.07212 6.95828 5.93795ZM7.49841 9.375C7.15324 9.375 6.87341 9.65482 6.87341 10C6.87341 10.3452 7.15324 10.625 7.49841 10.625C7.84359 10.625 8.12341 10.3452 8.12341 10C8.12341 9.65482 7.84359 9.375 7.49841 9.375Z",
      fill: "#A0A0A0"
    })]
  }));
};

QuestionMarkIcon.defaultProps = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CircleCheckIcon = function CircleCheckIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 3.33332C6.3181 3.33332 3.33333 6.31809 3.33333 9.99999C3.33333 13.6819 6.3181 16.6667 10 16.6667C13.6819 16.6667 16.6667 13.6819 16.6667 9.99999C16.6667 6.31809 13.6819 3.33332 10 3.33332ZM1.66666 9.99999C1.66666 5.39762 5.39762 1.66666 10 1.66666C14.6024 1.66666 18.3333 5.39762 18.3333 9.99999C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39762 18.3333 1.66666 14.6024 1.66666 9.99999Z",
      fill: "#41BD64"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0893 7.74408C13.4147 8.06951 13.4147 8.59715 13.0893 8.92259L9.75592 12.2559C9.43048 12.5814 8.90285 12.5814 8.57741 12.2559L6.91074 10.5893C6.5853 10.2638 6.5853 9.73618 6.91074 9.41074C7.23618 9.08531 7.76382 9.08531 8.08925 9.41074L9.16666 10.4882L11.9107 7.74408C12.2362 7.41864 12.7638 7.41864 13.0893 7.74408Z",
      fill: "#41BD64"
    })]
  }));
};

CircleCheckIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import SocialLinks from '../../SocialLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const ArticleMetaData = _ref => {
  let {
    authors,
    reviewer,
    updatedAt,
    createdAt,
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container, className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.main,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.main__segment,
        children: ["By", ' ', authors === null || authors === void 0 ? void 0 : authors.map((author, index) => {
          const isNotLast = index < authors.length - 1;
          return /*#__PURE__*/_jsx(AuthorLink, {
            data: author,
            appendText: isNotLast ? 'and' : ''
          }, index);
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.main__segment,
        children: [/*#__PURE__*/_jsxs("time", {
          className: styles.time,
          dateTime: dates.toIsoDate(updatedAt),
          children: ["Updated ", dates.toNumericDateDisplay(updatedAt)]
        }), ' | ', /*#__PURE__*/_jsxs("time", {
          className: styles.time,
          dateTime: dates.toIsoDate(createdAt),
          children: ["Published ", dates.toNumericDateDisplay(createdAt)]
        })]
      })]
    }), reviewer && /*#__PURE__*/_jsxs("div", {
      className: styles.footer,
      children: [/*#__PURE__*/_jsx(CircleCheckIcon, {
        className: styles.footer__circleCheck
      }), " Reviewed by", ' ', /*#__PURE__*/_jsx(AuthorLink, {
        data: reviewer
      })]
    })]
  });
};

export default ArticleMetaData;

const AuthorLink = _ref2 => {
  var _data$titles;

  let {
    data,
    appendText = ''
  } = _ref2;
  const certText = data.certifications ? `, ${data.certifications}` : '';
  const authorProfileUrl = `/authors/${data.slug}/`.replace(/\/+/g, '/');
  const position = data === null || data === void 0 ? void 0 : (_data$titles = data.titles) === null || _data$titles === void 0 ? void 0 : _data$titles.join(', ');
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const {
    refs,
    context,
    floatingStyles
  } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(14), shift()]
  });
  const hover = useHover(context);
  const focus = useFocus(context);
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([hover, focus]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("span", {
      className: styles.authorLink,
      children: [/*#__PURE__*/_jsx(Link, {
        href: authorProfileUrl,
        legacyBehavior: true,
        children: /*#__PURE__*/_jsxs("a", {
          className: styles.link,
          children: [data.fullName, certText]
        })
      }), /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({
        className: styles.questionMark,
        ref: refs.setReference
      }, getReferenceProps()), {}, {
        tabIndex: 0,
        children: [/*#__PURE__*/_jsx(QuestionMarkIcon, {}), isOpen && /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({
          ref: refs.setFloating,
          style: floatingStyles,
          className: styles.popover
        }, getFloatingProps()), {}, {
          children: [/*#__PURE__*/_jsxs("header", {
            className: styles.popover__header,
            children: [/*#__PURE__*/_jsx("img", {
              className: styles.popover__avatar,
              src: data.avatarUrl ? data.avatarUrl : '',
              alt: `${data.fullName}`
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.popover__header__content,
              children: [/*#__PURE__*/_jsxs("h6", {
                className: styles.minorHeader,
                children: [data.fullName, certText]
              }), /*#__PURE__*/_jsx("p", {
                className: styles.subHeading,
                children: position
              })]
            })]
          }), /*#__PURE__*/_jsx("p", {
            className: styles.popover__bio,
            children: truncate(data.articleBio || data.longBio || data.shortBio, {
              length: 97
            })
          }), /*#__PURE__*/_jsxs("footer", {
            className: styles.popover__footer,
            children: [/*#__PURE__*/_jsx(SocialLinks, {
              urls: data.socialUrls
            }), /*#__PURE__*/_jsx(Link, {
              href: authorProfileUrl,
              legacyBehavior: true,
              children: /*#__PURE__*/_jsx("a", {
                className: styles.primaryLink,
                children: "View Profile"
              })
            })]
          })]
        }))]
      }))]
    }), appendText && /*#__PURE__*/_jsx("span", {
      className: styles.authorLinkAppendText,
      children: appendText
    })]
  });
};